import { API_URL } from './constants';

const getApiOrigin = () => {
  try {
    const url = new URL(API_URL);
    return url.origin;
  } catch {
    return '';
  }
};

const API_ORIGIN = getApiOrigin();

export const resolveMediaUrl = (value) => {
  if (!value) return value;

  // Already absolute / special schemes
  if (/^(https?:|data:|blob:)/i.test(value)) return value;

  // Uploaded assets served by backend
  if (value.startsWith('/uploads/')) {
    return API_ORIGIN ? `${API_ORIGIN}${value}` : value;
  }

  // Static assets served by frontend (e.g. /avatars/...)
  return value;
};
